// MainLayout.tsx
import React from "react";
import Sidebar from "../SideBar";
import { Box } from "@mui/material";

type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <Sidebar />

      <Box component="main" sx={{ flexGrow: 1, width: "83%" }}>
        {children}
      </Box>
    </div>
  );
};

export default MainLayout;
